"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventSlugFromPath = void 0;

var tslib_1 = require("tslib");

function getEventSlugFromPath(pathname) {
  var _a; // eslint-disable-next-line no-useless-escape


  var SLUG_REGEX = /^\/organisers\/events\/(\w+(?:(?:-[\w]+)?)*)(?:\/.*)?/;

  var _b = tslib_1.__read((_a = SLUG_REGEX.exec(pathname)) !== null && _a !== void 0 ? _a : [], 2),
      slug = _b[1];

  return slug;
}

exports.getEventSlugFromPath = getEventSlugFromPath;